import { render, staticRenderFns } from "./processSpecifications.vue?vue&type=template&id=79ae9206&scoped=true&"
import script from "./processSpecifications.vue?vue&type=script&lang=js&"
export * from "./processSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./processSpecifications.vue?vue&type=style&index=0&id=79ae9206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae9206",
  null
  
)

export default component.exports